import { useState } from "react";
import { Flex, Box, Text } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../components/LanguageContext";
import { faqs_en, faqs_es } from "./textFiles/FAQData";

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      p={4}
      mb={4}
      backgroundColor={"#F0F0F0"}
      borderRadius="md"
      cursor="pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <Text fontSize={{ base: 20, lg: 24 }} color={"#555"} fontWeight="bold">
        {question}
      </Text>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Text fontSize={{ base: 16, lg: 18 }} mt={2}>
              {answer}
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

const FAQ = () => {
  const { language } = useLanguage();
  const isEnglish = language === "en";
  const faqs = (isEnglish ? faqs_en : faqs_es) || [];
  return (
    <>
      <Flex w="100%" justify="center" mt={8} px={8}>
        <Box textAlign="center">
          <Text fontSize={{ base: 28, lg: 40 }} fontWeight="bold">
            {isEnglish ? "Frequently Asked Questions" : "Preguntas Frecuentes"}
          </Text>
        </Box>
      </Flex>

      <Flex
        w="100%"
        justify="center"
        wrap="wrap"
        mt={8}
        px={8}
        direction="column"
        alignItems="center"
        marginBottom={10}
      >
        <Box w={{ base: "100%", lg: "60%" }}>
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </Box>
      </Flex>
    </>
  );
};

export default FAQ;
